import { ScenariosActionType } from './constants';

export const getDefaultState = () => ({
    all_scenarios: [], // Holds data related to all scenarios 
    scenario_selected: {label:"Gradual Aridity Increase", value:1},
});
export default (state = getDefaultState(), action) => {
    switch (action.type) {
      case ScenariosActionType.SET_ALL_SCENARIOS:
        return setAllScenarios(state, action);
      
      case ScenariosActionType.SET_SCENARIO_SELECTED:
        return setScenarioSelected(state, action);
      
      default:
        return state;
    }
};
const setAllScenarios = (state, { scenarios }) => {
    return {
      ...state,
      all_scenarios: scenarios,
    };
};

const setScenarioSelected = (state, { scenario }) => {
  return {
    ...state,
    scenario_selected: scenario,
  };
};
